// Detects both encoded and decoded email addresses. Copied from Shell team.
var emailRegex = new RegExp('[a-zA-Z0-9_\\-\\.]+(@|%40|%2540)[a-zA-Z0-9_\\-\\.]+\\.[a-zA-Z]{2,63}', 'g');
// Tries to detect local file paths like 'file://user/path'. These often contain PII, so are scrubbed.
var localFileRegex = new RegExp('file(:|%3A|%253A).*', 'gi');
//Will look for "userDisplayName: firstName lastName"
var userDisplayNameRegex = new RegExp(/"UserDisplayName":\s*"[^"]+"/g);
// TODO: Add tests
export function filterPii(data) {
    if (!data) {
        return data;
    }
    return data
        .replace(emailRegex, 'email_removed')
        .replace(localFileRegex, 'file_removed')
        .replace(userDisplayNameRegex, '"UserDisplayName": "username_removed"');
}
//# sourceMappingURL=filterPii.js.map